import * as apiGetVenueTrainingSessions from "@/api/campus/getVenueTrainingSessions";

import _ from "lodash";

export default {
  namespaced: true,
  state: {
    loading: false,
    venueTrainingSessions: []
  },
  mutations: {
    gotVenueTrainingSessions(state, result) {
      state.venueTrainingSessions = result;
    },

    isLoading(state, loading) {
      state.loading = loading;
    }
  },
  actions: {
    async getVenueTrainingSessions({ commit }) {
      commit("isLoading", true);

      const result = await apiGetVenueTrainingSessions.get();

      if (result) {
        commit("gotVenueTrainingSessions", result);
      }

      commit("isLoading", false);
    },
  },
  getters: {
    venueTrainingSessions: state => {
      return state.venueTrainingSessions;
    }
  }
};
